import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { getGuId } from "../../../utils/SecurityService";
import { getDisplayRefundCreditValue } from "../../../utils/CommonUtils";
import Close from "../../../assets/images/icons/close.svg";
import GrayStar from "../../../assets/images/icons/gray-star.svg";
import GreenMap from "../../../assets/images/icons/green-map.svg";
import EditSquare from "../../../assets/images/icons/edit-square.svg";
import ScheduleMeetingicon from "../../../assets/images/icons/schedule-meeting.svg";
import ParkingIcon from "../../../assets/images/icons/parkingIcon.svg";
import DeskIcon from "../../../assets/images/icons/DeskIcon.svg";
import MeetingIcon from "../../../assets/images/icons/meetingIcon.svg";
import CustomSearchableDropdown from "../../Common/CustomSearchableDropdown";
import { Images } from "../../Common/Images";
import { getLocalDateString, getSafeDisplayDate, getWeekKeyFromDate } from "./calendarMonthUtils";

const BookingModal = ({ date, onClose, zoneId, context }) => {
    const { t } = useTranslation();
    const {
        bookingCreateDate,
        clickedFullDay,
        weekData,
        bookingSpotData,
        zoneCreditValue,
        recordsData,
        preBookingQuestion,
        checkedPreBookingQue,
        setCheckedPreBookingQue,
        selectedTeamMember,
        selectedTeamId,
        isLoading,
        setPendingGuestBooking,
        setshowGuestPopupFullday,
        GetRandomSpace,
        selectedMemberData,
        selectedName,
        resetForm,
        iconzoneType,
        mapAvailable,
        mapAvailableType,
        GotoMapClick,
        teamMemberList,
        ScheduleMeeting,
    } = context;

    function getWeekKey(targetDate) {
        return getWeekKeyFromDate(targetDate);
    }

    const bookingDate = date || bookingCreateDate || clickedFullDay;
    const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
    const bookingDateStr = getLocalDateString(bookingDate);
    const bookingForModal =
        (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
            (booking) => booking.BookingDate === bookingDateStr
        )) ||
        bookingSpotData.find((booking) => booking.BookingDate === bookingDateStr);

    const safeBookingDate = getSafeDisplayDate(bookingDate);
    // Day, month and year must all come from the same date the modal was opened for.
    const displayDay = safeBookingDate ? safeBookingDate.getDate() : "";
    const displayMonth = safeBookingDate ? safeBookingDate.toLocaleDateString("en-US", { month: "long" }) : "";
    const displayYear = safeBookingDate ? safeBookingDate.getFullYear() : "";

    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedVehiclePrimaryKey, setSelectedVehiclePrimaryKey] = useState(null);
    const vehiclesForSpot = bookingForModal?.EmployeeVehicleType || [];

    useEffect(() => {
        if (vehiclesForSpot.length > 0 && !selectedVehiclePrimaryKey) {
            const firstVehicle = vehiclesForSpot[0];
            setSelectedVehiclePrimaryKey(firstVehicle.VehiclePrimaryKey);
            setSelectedVehicle(firstVehicle);
        }
    }, [vehiclesForSpot, selectedVehiclePrimaryKey]);

    const safeHtml = DOMPurify
        .sanitize(preBookingQuestion)
        .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

    const isGuestRandomAllocation = selectedTeamId === null && String(selectedTeamMember) === "0";
    const isVehicleRequiredForRandomSpace = !isGuestRandomAllocation && vehiclesForSpot.length > 0;
    const isVehicleSelectedForRandomSpace = isGuestRandomAllocation || !!selectedVehicle;
    const isDisabled =
        isLoading ||
        (isVehicleRequiredForRandomSpace && !isVehicleSelectedForRandomSpace) ||
        (!!preBookingQuestion && !checkedPreBookingQue);

    const bookingModalMemberName = isGuestRandomAllocation
        ? t("guest")
        : selectedMemberData?.FullName || selectedName || `${localStorage.getItem("firstname")} ${localStorage.getItem("lastname")}`;

    const requestRandomSpace = () => {
        if (isDisabled) return;

        const payload = {
            zoneId,
            bookingDateStr,
            VehicleTypeId: isGuestRandomAllocation ? 0 : selectedVehicle?.Id || 0,
            fuelId: isGuestRandomAllocation ? 0 : selectedVehicle?.FuelId || 0,
            vehicleShareableId: isGuestRandomAllocation ? 0 : selectedVehicle?.ShareableId || 0,
            vehicleAccessibleId: isGuestRandomAllocation ? 0 : selectedVehicle?.AccessibleId || 0,
            vehicleRegistrationId: isGuestRandomAllocation ? 0 : selectedVehicle?.VehicleRegistrationId || 0,
            isGuestFlag: isGuestRandomAllocation ? 1 : 0,
        };

        if (isGuestRandomAllocation) {
            setPendingGuestBooking({
                ...payload,
                spotName: bookingForModal?.SpotName || bookingForModal?.Schedules?.[0]?.SpotName || "",
                startTime: bookingForModal?.BookingStartTime || bookingForModal?.StartTime || "",
                endTime: bookingForModal?.BookingEndTime || bookingForModal?.EndTime || "",
            });
            setshowGuestPopupFullday(true);
            return;
        }

        GetRandomSpace(
            payload.zoneId,
            payload.bookingDateStr,
            payload.VehicleTypeId,
            payload.fuelId,
            payload.vehicleShareableId,
            payload.vehicleAccessibleId,
            payload.vehicleRegistrationId,
            0
        );
        onClose();
    };

    if (!bookingForModal) {
        return null;
    }

    const showScheduleMeeting = (teamMemberList.length == 0 || getGuId() == selectedTeamMember) && !isGuestRandomAllocation;
    const creditValueGrey =
        zoneCreditValue > 0 &&
        (bookingForModal?.IndividualDayCost == 0 || bookingForModal?.IndividualDayCost == "0");

    getDisplayRefundCreditValue({
        refundStartDateTime: bookingForModal?.RefundStartDateTime,
        refundEndDateTime: bookingForModal?.RefundEndDateTime,
        zoneCurrentDateTime: recordsData?.ZoneCurrentDateTime,
        fullRefundCredit: bookingForModal?.FullRefundCredit,
        halfRefundCredit: bookingForModal?.HalfRefundCredit,
        noRefundCredit: bookingForModal?.NoRefundCredit
    });

    return (
        <div>
            <div className="modal ctm-modalscroll-modal " style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }} id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="ctm-modal-header">
                                <div className="close-modal">
                                    <a onClick={resetForm}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">{t("react_calendar_new_booking")}</h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{displayDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>
                                    {zoneCreditValue > 0 && (
                                        <div className="credit-info">
                                            <a href="#" className="orange-outline-with-icon">
                                                {creditValueGrey ? (
                                                    <>
                                                        <img src={GrayStar} alt="star" />
                                                        <span>{bookingForModal?.IndividualDayCost}</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={Images.OrangeStar} alt="" />
                                                        <span>{Number(bookingForModal?.IndividualDayCost) > 0 ? `-${bookingForModal?.IndividualDayCost}` : bookingForModal?.IndividualDayCost}</span>
                                                    </>
                                                )}
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div className="divider-line mt-3"></div>
                            </div>

                            <div className="modal-des">
                                <div className="modal-scroll-inner">
                                    <div className="icon-with-list mb-3">
                                        <div className="icon-wrap">
                                            <img src={Images.Participant} />
                                            <h4 className="ps-1 ms-1">{bookingModalMemberName}</h4>
                                        </div>
                                    </div>

                                    {vehiclesForSpot.length > 0 && bookingForModal.DeskAvailable === 1 && !isGuestRandomAllocation && (
                                        <div className="custom-dropdown modal-dropdown mb-3">
                                            <CustomSearchableDropdown
                                                items={vehiclesForSpot}
                                                value={selectedVehiclePrimaryKey}
                                                labelKey="VehicleRegistrationId"
                                                valueKey="VehiclePrimaryKey"
                                                searchable={false}
                                                disabled={!vehiclesForSpot.length}
                                                onChange={(pk) => {
                                                    setSelectedVehiclePrimaryKey(pk);
                                                    const vehicleObj = vehiclesForSpot.find((v) => v.VehiclePrimaryKey === pk);
                                                    if (vehicleObj) {
                                                        setSelectedVehicle(vehicleObj);
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}

                                    <div className="participants-list ctm-checklist">
                                        {!!preBookingQuestion && (
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="preBookingQuestion"
                                                    checked={checkedPreBookingQue}
                                                    onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="preBookingQuestion">
                                                    <span dangerouslySetInnerHTML={{ __html: safeHtml }} />
                                                </label>
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-center my-34">
                                        {iconzoneType === 1 ? (
                                            <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                        ) : iconzoneType === 2 &&
                                            bookingForModal?.MeetingRoomAvailable === 1 &&
                                            bookingForModal?.HourlySpotAvailable === 0 &&
                                            bookingForModal?.DeskAvailable === 0 ? (
                                            <img src={MeetingIcon} className="img-fluid" alt="Meeting Room Booking" />
                                        ) : iconzoneType === 2 ? (
                                            <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                        ) : null}
                                    </div>
                                </div>

                               
                            </div>
                             <div className="ctm-modal-footer mt-3">
                                    {mapAvailable === 1 && mapAvailableType !== 1 && (
                                        <a onClick={() => GotoMapClick(zoneId, bookingDateStr)} className="green-outline-with-icon w-100 mw-100 min-height-56 selected" style={{ cursor: "pointer" }}>
                                            <img src={GreenMap} alt="Map" />
                                            <span>{t("gotomap")}</span>
                                        </a>
                                    )}

                                    {((mapAvailable === 0) || (mapAvailable === 1 && mapAvailableType !== 1 && bookingForModal.DeskAvailable === 1)) && (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                requestRandomSpace();
                                            }}
                                            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isDisabled ? "disabled" : ""}`}
                                            style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? "not-allowed" : "pointer" }}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                    <span>{t("loading")}</span>
                                                </>
                                            ) : (
                                                <>
                                                    <img src={EditSquare} alt="Edit" />
                                                    <span>{t("get_random_space")}</span>
                                                </>
                                            )}
                                        </a>
                                    )}

                                    {mapAvailable === 1 && mapAvailableType !== 1 && bookingForModal.MeetingRoomAvailable === 1 && showScheduleMeeting && (
                                        <a
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (!isLoading) {
                                                    ScheduleMeeting(zoneId, bookingDateStr);
                                                    onClose();
                                                }
                                            }}
                                            href="#"
                                            className="green-outline-with-icon w-100 mw-100 min-height-56"
                                        >
                                            <img src={ScheduleMeetingicon} alt="Edit" />
                                            <span>{t("react_schedule_meeting")}</span>
                                        </a>
                                    )}
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingModal;
